import { styled } from '@mui/material/styles';

export const StyledButton = styled('button')(({ theme }) => ({
  border: '1px solid transparent',
  background: `linear-gradient(${theme.colors.base08}, ${theme.colors.base08}),linear-gradient(90deg, #AB5FFF 1.14%, #1FEEFF 98.41%)`,
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',

  width: 'fit-content',

  borderRadius: '1rem',

  color: theme.colors.base01,

  padding: '0',

  '&:hover': {
    opacity: '0.8',
  },

  cursor: 'pointer',
}));

export const ContentContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  padding: '1.2rem',

  columnGap: '0.8rem',
});

export const ContentRightContainer = styled('div')({
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',
});

export const ContentRightTextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const ContentImageContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
